import React from 'react';
import { GroceryItem } from '../../types';
import { GroceryItemCard } from './GroceryItemCard';
import { Stack } from '../layout/Stack';

interface ItemListProps {
  items: GroceryItem[];
  emptyMessage: string;
  onToggleBought: (item: GroceryItem) => void;
  onToggleImportant: (item: GroceryItem) => void;
  onQuantityChange: (item: GroceryItem, delta: number) => void;
  onEdit: (item: GroceryItem) => void;
  compact?: boolean;
}

export const ItemList: React.FC<ItemListProps> = ({
  items,
  emptyMessage,
  onToggleBought,
  onToggleImportant,
  onQuantityChange,
  onEdit,
  compact = false,
}) => {
  if (items.length === 0) {
    return <p className="text-center text-gray-500 py-8">{emptyMessage}</p>;
  }

  return (
    <Stack direction="vertical" spacing={compact ? 1 : 2}>
      {items.map((item) => (
        <GroceryItemCard
          key={item._id}
          item={item}
          onToggleBought={onToggleBought}
          onToggleImportant={onToggleImportant}
          onQuantityChange={onQuantityChange}
          onEdit={onEdit}
          compact={compact}
        />
      ))}
    </Stack>
  );
};
